export default __webpack_public_path__ + "images/a4f333ecbdc99f102b2a31f0485b43a0.png";